import React from 'react';
export const content = (
  <React.Fragment>
    <p>Your puppy’s mental development is just as important as their physical health.</p>
    <p>
      During the first 1-2 years of your puppy’s life they are learning your routines, basic
      training, and learning about everything the world has to offer through socialization. It’s
      important to support your puppy’s development and create positive experiences throughout their
      puppyhood.
    </p>
  </React.Fragment>
);
